export default "Comparez les offres électricité et gaz B2B sans partenariat exclusif. Courtier indépendant des fournisseurs d'énergie, audit factures gratuit, optimisation TURPE/ATRD.";
